import React from "react";

const ComboBoxDropdownField = (props) => {
  const AlterTextField = (e) => {
    props.ReceivedTextData.call(undefined, {
      fieldName: e.target.name,
      fieldValue: e.target.value,
      optionLabel: `${e.target.name}_text`,
      optionLabelValue: e.target[e.target.selectedIndex].label,
      event: e,
    });
  };

  return (
    <>
      <div className={props.classDiv === true ? "field-container" : ""}>
        {props.label !== false && (
          <label
            className={`field-placeholder ${
              props.bold === true ? "font-medium" : ""
            }`}
          >
            {props.label}
          </label>
        )}
        <select
          className="field-input pt-1"
          maxLength={props.length}
          name={props.id}
          value={props.value}
          style={{
            backgroundColor:
              props.value && props.id == "Health_Score" ? props.color : "white",
          }}
          disabled={props.disabled ? props.disabled : false}
          id={props.id}
          onChange={(event) => AlterTextField(event)}
        >
          {props.options.length > 0 &&
            props.options.map((item, key) => (
              <option
                key={key}
                style={item.color ? { backgroundColor: item.color } : null}
                value={item.value}
              >
                {item.text}
              </option>
            ))}
        </select>
      </div>
      {props.requiredMsg && props.value.length < 1 && (
        <label className="requiredtext">Required</label>
      )}
    </>
  );
};
export default ComboBoxDropdownField;
